// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3mCyf","sendOtp":"AuthorizeToLogin_sendOtp__JAhSU"};